<template>
  <div class="image-uploader">
    <!--设置为#表示使用自定义上传-->
    <div v-if="imageUrl" class="preview" @mouseenter="showOverlay = true" @mouseleave="showOverlay = false">
      <div class="image-overlay" v-show="showOverlay">
        <i class="el-icon-delete" @click="clearImg" />
      </div>
      <el-image :src="BasrUrl + imageUrl"></el-image>
    </div>
    <el-upload
    action="#"
    :auto-upload="false"
    v-else
    :show-file-list="false"
    :on-change="handleFileChange"
    :before-upload="beforeUpload"
    :http-request="customUpload"
    accept=".png,.jpg,.jpeg,.svg"
    drag
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将图片拖到此处，或<em>点击上传</em>
        <div class="el-upload__tip">只能上传 PNG/JPG/SVG 格式图片</div>
      </div>
    <template #tip>
      <div v-if="errorMsg" class="el-upload__error">{{ errorMsg }}</div>
    </template>
    </el-upload>
  </div>
</template>

<script>
import {fileUpLoad} from '@/API/news/news'
import axios from "axios";
export default {
  name: 'ImageUpload',
  emits: ['upload-success', 'upload-error'],  // 定义自定义事件
  data() {
    return {
      imageUrl:undefined,
      fileName:'',
      BasrUrl:process.env.VUE_APP_BASE_URL,
      errorMsg: '',
      allowedTypes: ['image/png', 'image/jpeg', 'image/svg+xml'],
      allowedExtensions: ['.png', '.jpg', '.jpeg', '.svg'],
      showOverlay: false  // 控制遮罩层显示
    }
  },
  methods: {
    // 文件选择变化时触发
    handleFileChange(file, fileList) {
      this.errorMsg = ''
      if (!this.validateFile(file)) {
        return false
      }
      // 手动触发上传（因为auto-upload=false）
      this.customUpload({ file })
    },

    // 上传前校验
    beforeUpload(file) {
      return this.validateFile(file)
    },

    // 自定义上传逻辑
    customUpload(options) {
      const { file } = options
      if (!this.validateFile(file)) return
      // 这里替换为你的实际上传逻辑
      this.uploadToServer(file)
        .then(response => {
          console.log(response,'responseresponseresponse')
          this.imageUrl=response,
          this.fileName=file.name,
          this.$emit('upload-success', {
            url: response,
            fileName: file.name
          })
        })
        .catch(error => {
          this.$emit('upload-error', {
            error,
            fileName: file.name
          })
          this.errorMsg = '上传失败: ' + error.message
        })
    },

    // 文件校验
    validateFile(file) {
      // 校验文件类型
      const isTypeValid = this.allowedTypes.includes(file.type) ||
        this.allowedExtensions.some(ext => file.name.toLowerCase().endsWith(ext))

      if (!isTypeValid) {
        this.errorMsg = `不支持的文件格式，请上传 ${this.allowedExtensions.join('/')} 格式图片`
        return false
      }

      // 校验文件大小（示例：5MB限制）
      const isSizeValid = file.size / 1024 / 1024 <= 5
      if (!isSizeValid) {
        this.errorMsg = '图片大小不能超过5MB'
        return false
      }

      return true
    },

    // 模拟上传到服务器（替换为你的实际API调用）
    uploadToServer(file) {
      return new Promise((resolve, reject) => {
        // 这里使用模拟上传延迟
        const formData = new FormData()
        console.log(file.raw,'file.raw')
        formData.append('file', file.raw)
        fileUpLoad(formData)
          .then(response => {
            console.log(response,'responseresponseresponse')
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    clearImg(){
      this.imageUrl = null
      this.$emit('upload-change', {
        url: '',
        fileName: ''
      })
    }
  }
}
</script>

<style lang="less" scoped>
.image-uploader {
  width: 100%;
}

.el-upload {
  width: 100%;
}

.el-upload-dragger {
  width: 100%;
  padding: 20px;
}

.el-upload__tip {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}

.el-upload__error {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 10px;
}
/deep/.el-icon-upload{
  margin-top: 20px!important;
}
/deep/.el-upload-dragger {
  width: 100% !important;
}
/deep/.el-upload{
  width: 100% !important;
}
.preview{
  height: 180px;
  width: 100%!important;
  width: fit-content;
  position: relative;
  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9;
  }
  .el-icon-delete {
    color: #ffffff;
    font-size: 36px;
    cursor: pointer;
    z-index: 10;
  }
  .el-image{
    height: 100%;
    width: 100%;
  }
}
</style>
